var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 50,
    height: 50,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v13h3v-2h8v2h2.81A3.001 3.001 0 0 0 21 19a3.001 3.001 0 0 0-3-3h-1V9H8V3H3zm12 7v4h3v-4h-3zm-9-7h7v6H6V3zm8 11h-8v3H4v2h2a2.99 2.99 0 0 0 5.67 0h3.66A3 3 0 0 0 21 17h-3v-3h-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1f60936694339b4e887791d0939a3650.svg";
export { ForwardRef as ReactComponent };